'use client';

import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';
import { IconButton } from '../../../core-components';

// Root component for the Popover.
const Popover = PopoverPrimitive.Root;

// Trigger component for opening the Popover.
const PopoverTrigger = PopoverPrimitive.Trigger;

// Anchor component for positioning the Popover.
const PopoverAnchor = PopoverPrimitive.Anchor;

/**
 * Props for the PopoverContent component.
 */
export type PopoverContentProps = React.ComponentPropsWithoutRef<
  typeof PopoverPrimitive.Content
>;

/**
 * PopoverContent displays the content inside the popover.
 */
const PopoverContent = (props: PopoverContentProps) => {
  const { align = 'center', sideOffset = 4, children } = props;

  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        align={align}
        side={'top'}
        sideOffset={sideOffset}
        avoidCollisions
        collisionPadding={16}
        className="z-popover w-[312px] rounded-sm bg-surface-white px-4 pb-6 pt-2 drop-shadow-md md:max-w-[232px]"
      >
        <div className="flex">
          <PopoverPrimitive.Close asChild>
            <IconButton
              iconName="cancel"
              variant="ghost"
              size="sm"
              className="ml-auto"
              aria-label="popover-close"
            />
          </PopoverPrimitive.Close>
        </div>
        <div className="gap-2 text-marine-high-emphasis">{children}</div>
        <div className="absolute bottom-0 left-0 right-0 z-10 h-2 w-full rounded-md bg-surface-white" />
        <PopoverPrimitive.Arrow className="h-3 w-5 fill-white drop-shadow-md" />
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  );
};

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
